import $ from 'jquery';
import SyosEvents from './utils/SyosEvents';
import SyosMaximumSeatsReachedModal from './modals/SyosMaximumSeatsReachedModal';
import SyosRemoveSeatConfirmationModal from './modals/SyosRemoveSeatConfirmationModal';
import { testIsFakeMozMouseEvent, EventHandler, EventHandlerList } from '../utils/dom-events';
import GestureHelper from './utils/GestureHelper';

/*
const apiData = {
  CustomFill: '#FF0000',
  CustomProperties: {},
  FriendName: null,
  GraphicType: 'CIRCLE',
  PictureLink: null,
  SeatSelectionText: 'Thank you, this seat has been added to your order.',
  StageOrientation: 'Top',
  ZoneLabel: 'Balcony',
  ac_no: 0,
  display_letter: ' ',
  hc_no: 0,
  imageURL: null,
  is_seat: true,
  line_item_no: null,
  seat_desc: '',
  seat_no: 8608,
  seat_num: '103       ',
  seat_row: 'D         ',
  seat_status: 0,
  seat_status_desc: 'Available',
  seat_type: 1,
  seat_type_desc: 'Regular',
  section: 2,
  xpos: 20,
  ypos: 5,
  zone_no: 26,
};
*/


/*
Status Reference

0   AVL   Available
1   HBR   Held, breakable
2   LRS   Locked by this session, Reserving
3   LCK   Locked
4   HLD   Held
5   NIA   Not In Allocation
6   BLK   Blacked Out
7   RUP   Reserved, Unpaid
8   RPD   Reserved, Paid
9   NS    Non-Seat
10  CPP   Upgrade Product Paid
11  RTC   Reserved by this customer
12  RTO   Reserved in this Order
13  TKD   Ticketed
14  TKC   Ticketed to this customer
15  TKO   Ticketed in this order
16  LRL   Locked by this session, Releasing
17  LRT   Locked by this session, Returning
18  DFR   Donated For Resale
19  CPU   Upgrade Product Unpaid
20  CSP   Upgrade Seats Paid
21  CSU   Upgrade Seats Unpaid
22  ENT   Entered House
*/

let isPressing = false;
let didMoveAfterPress = false;


function onRelease() {
  didMoveAfterPress = false;
  isPressing = false;
}

function applySeatElementStyling($el, className, color, iconType) {
  if (className !== null) {
    $el.addClass(className);
  }
  if (color !== null) {
    $el.css({ color });
  }

  $el.attr('xlink:href', `#tn-syos-seat-map-icon-${iconType}`);
}


class SyosSeat {
  static adjustValueForGrid(value) {
    return (SyosSeat.GRID_UNIT_SIZE * value) + (SyosSeat.GRID_MARGIN * value);
  }

  constructor(syosController, apiData) {
    this.syosController = syosController;
    this.apiData = apiData;
    this.selectedPriceType = null;
    this.isViewingInPriceTypeSelector = false;
    this.bindMethods();
  }

  get zoneId() { return this.apiData.zone_no; }
  get id() { return this.apiData.seat_no; }
  get number() { return this.apiData.seat_num.trim(); }
  get row() { return this.apiData.seat_row.trim(); }
  get statusDescription() { return this.apiData.seat_status_desc; }
  get description() { return this.apiData.seat_desc; }
  get zoneLabel() { return this.apiData.ZoneLabel; }
  get status() { return this.apiData.seat_status; }
  get type() { return this.apiData.seat_type; }
  get sectionId() { return this.apiData.section; }
  get sectionDescription() { return this.getSection().section_desc; }

  get x() { return SyosSeat.adjustValueForGrid(this.apiData.xpos); }
  get y() { return SyosSeat.adjustValueForGrid(this.apiData.ypos); }
  get fillColor() { return this.apiData.CustomFill; }

  get iconType() {
    if (this.getIsInTempCart()) {
      return 'donut';
    }
    switch (this.apiData.GraphicType) {
      case 'WHEELCHAIR':
        return 'wheelchair';
      case 'STAR':
        return 'star';
      default:
        return 'circle';
    }
  }

  get price() {
    return this.selectedPriceType.price;
  }
  get feeDisclaimer() {
    return this.selectedPriceType.feeDisclaimer;
  }
  get priceWithFee() {
    return this.selectedPriceType.priceWithFee;
  }
  get displayPrice() {
    return this.selectedPriceType.displayPrice;
  }
  get selectedPriceTypeId() {
    return this.selectedPriceType.price_type;
  }
  get selectedPriceTypeDescription() {
    return this.selectedPriceType.price_type_desc;
  }

  getClientRect() {
    return this.$el[0].parentNode.getBoundingClientRect();
  }

  bindMethods() {
    this.onPress = this.onPress.bind(this);
    this.onMouseOver = this.onMouseOver.bind(this);
    this.onMouseLeave = this.onMouseLeave.bind(this);
    this.onPanMove = this.onPanMove.bind(this);
    this.onPanEnd = this.onPanEnd.bind(this);
    this.onClick = this.onClick.bind(this);
  }

  setEl(el) {
    this.gestureHelper = new GestureHelper(el, {
      onPress: this.onPress,
      onPanMove: this.onPanMove,
      onPanEnd: this.onPanEnd,
      onClick: this.onClick,
      onRelease,
      makeKeyboardClickable: true,
      // debugId: `Seat ${this.id}`,
    }).start();

    this.mouseHandlers = new EventHandlerList([
      new EventHandler(el, 'mouseover', this.onMouseOver),
      new EventHandler(el, 'mouseleave', this.onMouseLeave),
    ]).start();

    this.$el = $(el);
    this.updateUiState();
  }

  onPress() {
    isPressing = true;
    didMoveAfterPress = false;
    this.trigger(SyosEvents.SEAT_MOUSE_PRESS);
  }

  onPanMove() {
    if (didMoveAfterPress === true) {
      this.trigger(SyosEvents.SEAT_MOUSE_LEAVE);
    }
    didMoveAfterPress = true;
  }

  onMouseOver(event) {
    if (
      isPressing ||
      event.timeStamp === 0 ||
      testIsFakeMozMouseEvent(event)
    ) {
      return;
    }

    this.trigger(SyosEvents.SEAT_MOUSE_OVER);
  }

  onMouseLeave() {
    this.trigger(SyosEvents.SEAT_MOUSE_LEAVE);
  }

  trigger(syosEventName) {
    this.syosController.emit(syosEventName, { seat: this });
  }

  detach() {
    this.gestureHelper.stop();
    this.gestureHelper = null;

    this.mouseHandlers.stop();
    this.mouseHandlers = null;

    this.$el = null;
  }

  onPanEnd(event) {
    if (didMoveAfterPress === true) {
      if (event.type === 'mouseup' && event.target === this.$el[0]) {
        this.trigger(SyosEvents.SEAT_MOUSE_OVER);
      }
    }
  }

  onClick(event) {
    event.preventDefault();

    if (
      this.getIsAvailable() === false ||
      this.getPriceTypes().length === 0
    ) {
      return;
    }

    const isRemovingSeat = this.getIsInTempCart();

    if (isRemovingSeat) {
      this.trigger(SyosEvents.SEAT_MOUSE_LEAVE);
      SyosRemoveSeatConfirmationModal.open(this.syosController, this);
    } else {
      if (this.syosController.getCartContainer().maximumSeatCountReached()) {
        this.trigger(SyosEvents.SEAT_MOUSE_LEAVE);
        SyosMaximumSeatsReachedModal.open(this.syosController);
      } else {
        this.trigger(SyosEvents.SEAT_CLICK);
      }
    }
  }

  getIsViewingInPriceTypeSelector() {
    return this.isViewingInPriceTypeSelector;
  }

  setIsViewingInPriceTypeSelector(value) {
    this.isViewingInPriceTypeSelector = value;
  }

  testContainsElement(element) {
    if (!this.$el) {
      return false;
    }

    const el = this.$el[0];
    if (el.contains) {
      return this.$el[0].contains(element);
    }

    // IE11 doesn't support node.contains() on svg elements
    if (el === element) {
      return true;
    }

    let parent = element.parentNode;

    while (parent) {
      if (parent === el) {
        return true;
      }
      parent = parent.parentNode;
    }
    return false;
  }

  removeFromCart() {
    this.selectedPriceType = null;
    if (this.$el) {
      this.updateUiState();
    }
    this.trigger(SyosEvents.SEAT_REMOVED);
  }

  selectPriceType(priceTypeId) {
    const priceType = this.syosController.getDataService().getPriceType(this.zoneId, priceTypeId);
    this.selectedPriceType = priceType;
    this.updateUiState();
    this.trigger(SyosEvents.SEAT_SELECTED);
  }

  getPriceTypes() {
    return this.syosController.getDataService().getZonePriceTypes(this.zoneId);
  }

  getSection() {
    return this.syosController.getDataService().getSection(this.sectionId);
  }

  getTemplateData() {
    const priceTypes = this.getPriceTypes();
    const additionalModalText = this.syosController.getDataService().getPerfAdditionalModalText();

    return {
      seat: this,
      priceTypes,
      additionalModalText,
    };
  }

  getIsAvailable() {
    return this.status === 0;
  }

  getIsInTempCart() {
    return this.selectedPriceType !== null;
  }

  updateUiState() {
    let color = null;
    let className = null;

    if (this.getIsAvailable() === false) {
      className = SyosSeat.CSS_CLASS_UNAVAILABLE;
    } else {
      color = this.fillColor;
    }

    applySeatElementStyling(this.$el, className, color, this.iconType);

    window.requestAnimationFrame(() => {
      if (this.$el) {
        applySeatElementStyling(this.$el, className, color, this.iconType);
      }
    }); // Breather for IE11
  }
}

SyosSeat.CSS_CLASS = 'tn-syos-seat-map__seat';
SyosSeat.CSS_CLASS_UNAVAILABLE = 'tn-syos-seat-map__seat--unavailable';

SyosSeat.GRID_UNIT_SIZE = 60;
SyosSeat.GRID_MARGIN = 12;

export default SyosSeat;



// WEBPACK FOOTER //
// ./V7/syos/SyosSeat.js